export default __webpack_public_path__ + "static/media/eye.6c473588.svg";